import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  NgControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DialogObservationComponent } from './dialog-observation/dialog-observation.component';

@UntilDestroy()
@Component({
  selector: 'bs-observation',
  templateUrl: './observation.component.html',
  styleUrls: ['./observation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ObservationComponent,
      multi: true,
    },
  ],
})
export class ObservationComponent implements ControlValueAccessor {
  @Input() isEditable!: boolean;
  @Input() ambientes!: string[];
  value!: { observacao?: any; ambiente?: any };
  ngControl!: NgControl | null;
  onChange?: (value: { observacao: any; ambiente: any }) => void;
  onTouched?: () => void;

  constructor(
    public dialog: MatDialog,
    readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  writeValue(value: { observacao?: string; ambiente?: string }): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  getTypeIcon() {
    return this.value?.observacao || this.value?.ambiente;
  }

  openDialog() {
    this.dialog
      .open(DialogObservationComponent, {
        width: 'min(500px, 100%)',
        autoFocus: false,
        data: {
          observacao: this.value,
          isEditable: this.isEditable,
          ambientes: this.ambientes,
        },
      })
      .afterClosed()
      .subscribe((observation) => {
        if (!observation || !observation.isSaved) return;
        this.onChange?.apply(this, [
          { observacao: observation.value, ambiente: observation.ambiente },
        ]);
        this.writeValue({
          observacao: observation.value,
          ambiente: observation.ambiente,
        });
        this.changeDetectorRef.detectChanges;
      });
  }
}
